import { Button, Form as BTForm } from "react-bootstrap";
import Card from "../../../../components/Cards/Basic";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../../config/axios";
import { showSuccessToast } from "../../../../components/Toasts";
import history from "../../../../global/history";
import BackButton from "../../../../components/UiComponents/Buttons/BackButton";
import { linkBuilder } from "../../../../global/navigationHelper";
import EditInvoiceForm from "../../EditInvoiceForm";
import { useTranslation } from "react-i18next";

const EditBookingInvoicePage = () => {
  const { stayId, id } = useParams();
  const [invoice, setInvoice] = useState();
  const formRef = useRef();
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    if (id) {
      getInvoice();
    }
  }, []);

  function getInvoice() {
    axios.get(`/api/v1/invoices/${id}.json`).then(function (response) {
      setInvoice(response.data);
    });
  }

  function updateInvoice(data) {
    if (id) {
      axios
        .put(`/api/v1/invoices/${id}.json`, { invoice: data })
        .then(function (response) {
          setInvoice(response.data);
          showSuccessToast();
          history.push(`/dashboard/stays/${stayId}`);
        });
    } else {
      axios
        .post(`/api/v1/stays/${stayId}/invoices.json`, { invoice: data })
        .then(function (response) {
          setInvoice(response.data);
          showSuccessToast();
          history.push(`/dashboard/stays/${stayId}`);
        });
    }
  }

  return (
    <Card
      title={
        <div className={"d-flex align-items-center"}>
          <BackButton
            fallbackRoute={linkBuilder("/dashboard/stays/" + stayId)}
          />
          <span>Rechnung</span>
        </div>
      }
      footer={
        <div>
          <Button
            variant="primary"
            className={"mr-1"}
            onClick={() => formRef?.current?.handleSubmit()}
            disabled={formRef?.current?.isSubmitting}
          >
            {t("common:components.button.save")}
          </Button>
        </div>
      }
    >
      <EditInvoiceForm
        formRef={formRef}
        invoice={invoice}
        handleSubmit={(data) => {
          updateInvoice(data);
        }}
      />
    </Card>
  );
};

export default EditBookingInvoicePage;
